<template>
    <div class="popup-container">
        <div class="main-content">
            <div class="pop-title">详情</div>
            <div class="info-title">{{data.title}}</div>
            <div class="content">
                <div class="data">{{data.data}}</div>
                <div class="txt">上市孵化器</div>
                <div class="txt">{{data.time}}</div>
            </div>
            <div class="close" @click="close()">关闭</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PopupM',
    props: ['data'],
    data() {
        return {}
    },
    methods: {
        close() {
            this.$emit('appPopupShow', false);
        }
    }
}
</script>
<style lang="scss" scoped>
@import './PopupM.scss';
</style>


// WEBPACK FOOTER //
// src/components/mobile/common/popup/PopupM.vue